export default __webpack_public_path__ + "static/media/ascenseur.893569b4.svg";